import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { VendorMark } from '../brand'
import { trackWhatsAppClick } from '../utils/analytics'

/**
 * CTA flutuante do WhatsApp (D15): marca de terceiro MONOCROMÁTICA em chapa da superfície oposta ao documento
 * (tinta sobre papel), sem o verde do fornecedor, sem sombra, raio pela razão. Preserva o evento whatsapp_click (canal de conversão medido);
 * reavaliar remoção aos 28 dias de campo (docs/ROADMAP.md).
 */
const PHONE = '5511915629996'

export default function WhatsAppFloat() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  if (pathname.startsWith('/__')) return null
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t('common.whatsappMessage'))}`
  return (
    <a
      className="z-wa"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${t('common.openWhatsApp')} — ${t('common.whatsappContact')}`}
      data-surface="dark"
      onClick={() => trackWhatsAppClick(pathname)}
    >
      <VendorMark vendor="whatsapp" size={22} />
      <span className="z-wa__rotulo">{t('common.openWhatsApp')}</span>
    </a>
  )
}
